module.exports = __webpack_public_path__ + "img/DezembroVermelho-Banner-1080x200.fea050af.jpg";